/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecuteActionRecommendationResponse {
    getFixupPrototypeFunction() { return ExecuteActionRecommendationResponse.fixupPrototype; }

    static newInstance(model: Partial<ExecuteActionRecommendationResponse>): ExecuteActionRecommendationResponse {
        let obj = Object.assign(new ExecuteActionRecommendationResponse(), model);
        ExecuteActionRecommendationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecuteActionRecommendationResponse>): ExecuteActionRecommendationResponse {
        if (!model) return null;
        return ExecuteActionRecommendationResponse.newInstance(<ExecuteActionRecommendationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecuteActionRecommendationResponse) {
        if (!obj) return;

        models.ExecuteActionRecommendationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecuteActionRecommendationResponse): boolean {
        Object.setPrototypeOf(obj, ExecuteActionRecommendationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of pre-execute
     */
    status: string;

    /**
     * pre-execute
     */
    message: string;

    /**
     * Data for pre-execute
     */
    data: any;

}
